export default {
  "settings": {
    "title": "Settings",
    "screen": {
      "organization": "Organization settings",
      "workspace": "Workspace settings",
      "members": "Members",
      "connections": "Connections",
      "account": "Account"
    },
    "section": {
      "workspace": "Workspace · {name}",
      "organization": "Organization · {name}",
      "personal": "You"
    },
    "connectionsTab": {
      "desc": "The sources this workspace pulls data from."
    },
    "membersTab": {
      "desc": "Who can open the {workspaceName} workspace, and with which role."
    },
    "homeTab": {
      "header": "Home",
      "title": "Home",
      "desc": "The landing page for everyone in the {workspaceName} workspace. Each workspace sets its own Home.",
      "current": "Home dashboard",
      "change": "Change dashboard",
      "preview": "Preview Home",
      "clear": "Clear Home dashboard",
      "clearHint": "Everyone sees the empty state until a new one is picked.",
      "none": "No Home dashboard yet. Everyone in this workspace sees the empty state.",
      "missing": "The Home dashboard is no longer available. Pick another one.",
      "switchNote": "Switching workspace switches Home too. Each workspace has its own Home dashboard, set in its own settings."
    }
  }
};
